@if (!isAccepted) {
<app-disclaimer
  [interaction]="interaction"
  (accepted)="termsAccepted($event)"
  (rejected)="termsRejected()"
></app-disclaimer>
} @if (isAccepted) {
<h1 class="title" translate>Video call</h1>
@if (isCallbackWaitingVisible) {
<div class="callback-hud" [@slideInOut]="true">
  <h2 translate>Please wait</h2>
  <p translate>The next available agent will be with you shortly</p>
</div>
}
<app-room-ui
  [interaction]="interaction"
  [recorderOptions]="recorderOptions"
  (callEnding)="callEnding($event)"
  (callStarted)="callStarted()"
  (exit)="exit()"
  (callEnded)="callEnded($event)"
  (recorderStarted)="recorderStarted($event)"
  (recorderStopped)="recorderStopped($event)"
  (deviceSetupComplete)="deviceSetupDoneAndRoomJoined()"
  (callPendingRating)="callPendingRating($event)"
  (layoutChange)="viewChange($event)"
  (remotePopupClosed)="remotePopupClosed()"
>
</app-room-ui>
@if (QRData) {
<app-qr [data]="QRData" [@centerInOut]="true" (close)="closeQRPanel()"></app-qr>
} @if (isMessagingAvailable) {
<app-conversation-launcher
  [interaction]="interaction"
  class="options-container"
></app-conversation-launcher>
} @if (shouldShowShareOptions) {
<app-share-link
  #shareLinkOptions
  [interaction]="interaction"
  [isOriginWidgetWithoutVideo]="isOriginWidgetWithoutVideo"
  [smsFlow]="shareViaSMSFlow()"
></app-share-link>
} }
